import { useRef, useState } from 'react';
import { Upload, Loader2 } from 'lucide-react';
import { Button } from '@libero/core/components/ui/button';

interface Props {
  laeuft: boolean;
  onDateien: (dateien: File[]) => void;
}

/** Drag & Drop oder Auswahl: Foto(s) vom Zettel, PDF, Excel/CSV. Mehrere Dateien = mehrere Seiten. */
export default function UploadBereich({ laeuft, onDateien }: Props) {
  const input = useRef<HTMLInputElement>(null);
  const [drueber, setDrueber] = useState(false);

  return (
    <div
      onDragOver={(e) => { e.preventDefault(); setDrueber(true); }}
      onDragLeave={() => setDrueber(false)}
      onDrop={(e) => {
        e.preventDefault();
        setDrueber(false);
        if (!laeuft && e.dataTransfer.files.length) onDateien([...e.dataTransfer.files]);
      }}
      className={`rounded-lg border-2 border-dashed p-8 text-center transition-colors ${
        drueber ? 'border-[#1A1A1A] bg-[#E9FF57]/30' : 'border-[#DAD9D9] bg-white'
      }`}
    >
      {laeuft ? (
        <div className="flex flex-col items-center gap-2 text-[#1A1A1A]">
          <Loader2 className="h-8 w-8 animate-spin" />
          <p className="font-medium">Liste wird gelesen …</p>
          <p className="text-sm text-gray-500">Handschrift dauert etwa 20–60 Sekunden.</p>
        </div>
      ) : (
        <div className="flex flex-col items-center gap-3">
          <Upload className="h-8 w-8 text-gray-400" />
          <div>
            <p className="font-medium text-[#1A1A1A]">Kundenliste hierher ziehen</p>
            <p className="text-sm text-gray-500">Foto vom Zettel, Scan, PDF oder Excel — mehrere Seiten auf einmal möglich</p>
          </div>
          <Button onClick={() => input.current?.click()} className="bg-[#E9FF57] text-[#1A1A1A] hover:bg-[#d4ea4d]">
            Datei auswählen
          </Button>
          <input
            ref={input}
            type="file"
            multiple
            accept="image/*,.heic,.pdf,.xlsx,.xls,.csv,.ods"
            className="hidden"
            onChange={(e) => {
              if (e.target.files?.length) onDateien([...e.target.files]);
              e.target.value = '';
            }}
          />
        </div>
      )}
    </div>
  );
}
